import {AppState} from '../context';
import {tokenStorage} from '@app/storage/tokenStorage';
import {userFromToken, userStorage} from '@app/storage/userStorage';
import {emitOrdersUpdate, UpdateOrdersEvent} from './emits/emitOrdersUpdate';
import {clearLogoutTimer} from '@utils';
import {emitOrdersConfigUpdate, UpdateOrdersConfigEvent} from './emits/emitOrdersConfigUpdate';
import {emitSelectClient, SelectClientEvent} from './emits/emitSelectClient';
import {ClientSelectionErrorEvent, emitClientSelectionError} from './emits/emitClientSelectionError';
import {emitSearchConfigUpdate, UpdateSearchConfigEvent} from './emits/emitSearchConfigUpdate';
import {emitReportPercentsUpdate, IEmitReportPercentsUpdate,} from './emits/emitReportPercentsUpdate';
import {emitClientsConfigUpdate, UpdateClientsConfigEvent} from "./emits/emitClientsConfigUpdate";

export type EventName =
    | 'login'
    | 'logout'
    | 'updateOrders'
    | 'updateOrdersConfig'
    | 'selectClient'
    | 'clientSelectionError'
    | 'updateSearchConfig'
    | 'updateReportPercents'
    | 'updateFiltersRP'
    | 'updateReportItemsUpdate'
    | 'updateSearchInputMainHeader'
    | 'updateClientsConfig';

export const createEmitter = (setState: React.Dispatch<React.SetStateAction<AppState>>) => {
    return (name: EventName, event?: object) => {
        switch (name) {
            case 'logout':
                emitLogout(setState, event as LogoutEvent);
                break;
            case 'login':
                emitLogin(setState, event as LoginEvent);
                break;
            case 'updateOrders':
                emitOrdersUpdate(setState, event as UpdateOrdersEvent);
                break;
            case 'updateOrdersConfig':
                emitOrdersConfigUpdate(setState, event as UpdateOrdersConfigEvent);
                break;
            case 'selectClient': // выбор в главном хедере клиента
                emitSelectClient(setState, event as SelectClientEvent);
                break;
            case 'clientSelectionError': // ошибка если клиент не выбран
                emitClientSelectionError(setState, event as ClientSelectionErrorEvent);
                break;
            case 'updateReportPercents':
                emitReportPercentsUpdate(setState, event as IEmitReportPercentsUpdate);
                break;
            case 'updateSearchConfig':
                emitSearchConfigUpdate(setState, event as UpdateSearchConfigEvent);
                break;
            case 'updateClientsConfig':
                emitClientsConfigUpdate(setState, event as UpdateClientsConfigEvent);
                break;
        }
    };
};

interface LogoutEvent {
    redirectTo: string;
}

function emitLogout(setState: React.Dispatch<React.SetStateAction<AppState>>, event: LogoutEvent) {
    userStorage.clear();
    tokenStorage.clear();

    // Очистка таймера логаута при выходе вручную
    clearLogoutTimer();

    window.location.href = event?.redirectTo || '/';
}

interface LoginEvent {
    token: string;
    rememberMe: boolean;
}

function emitLogin(setState: React.Dispatch<React.SetStateAction<AppState>>, event: LoginEvent) {
    userStorage.clear();
    tokenStorage.clear();

    if (event.rememberMe) {
        tokenStorage.setLocal(event.token);
    } else {
        tokenStorage.setSession(event.token);
    }

    userStorage.set(userFromToken(event.token));

    setState((prevState: AppState) => ({
        ...prevState,
        user: userStorage.get()!,
        token: tokenStorage.get()!
    }));
}
